import { Record } from 'immutable';

const BrowseItem = Record(
  {
    pandoraId: '',
    stationFactory: '',
    key: '',
    hoverText: '',
    firstLineText: '',
    secondLineText: '',
    thirdLineText: '',
    webUrl: '',
    analyticsToken: '',
    artId: '',
    fullUrl: '',
    isCircular: false,
    isBlank: false,
  },
  'BrowseItem',
);

export default BrowseItem;
